import { Box, Divider, LinearProgress, Stack, Tooltip, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';

const ReelsProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 4,
    width: '100%',
    backgroundColor: '#F0F0F0',
    '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        background: '#f444f0',
    },
}));

const Interactions = ({ data }) => {

    return (
        <Box>
            <Box display={"flex"} alignItems={"center"} gap={0.5} margin={"3rem 0 0 0"}>
                <Typography variant="h6">Interactions</Typography>

                <Tooltip title={data.raw_data.description} arrow>
                    <InfoIcon fontSize="small" sx={{ margin: 0 }} />
                </Tooltip>
            </Box>

            <Box display={"flex"} alignItems={"center"} margin={"0.5rem 0 0 0"} gap={"1rem"} justifyContent={"space-around"}>
                <Box width={"30%"}>
                    <Typography variant="h6">{data.raw_data.total_value.value}</Typography>
                    <Typography component="p" fontSize={"0.85rem"}>Views</Typography>
                </Box>

                <Divider orientation="vertical" flexItem />

                <Box width={"60%"}>
                    <Typography variant="h6">
                        By content type
                    </Typography>

                    <Box
                        sx={{
                            width: '100%',
                            maxWidth: 500,
                            pt: 3,
                        }}
                    >
                        <Stack spacing={1} sx={{ width: "100%" }}>
                            {
                                data.raw_data.total_value.breakdowns[0].results.map((stat) => {

                                    return (
                                        <Box
                                            key={stat.dimension_values[0]}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly',
                                                width: '100%'
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: 'black',
                                                    fontWeight: 500,
                                                    width: '10%',
                                                    maxWidth: '10%',
                                                    fontSize: '0.85rem',
                                                    textTransform: 'capitalize',
                                                    wordBreak: 'break-word',
                                                }}
                                                component={"p"}
                                            >
                                                {stat.dimension_values[0].toLowerCase()}
                                            </Typography>
                                            <Box sx={{ flexGrow: 1, mx: 2 }}>
                                                <ReelsProgress variant="determinate" value={(stat.value / data.raw_data.total_value.value) * 100} />
                                            </Box>
                                            <Typography
                                                sx={{
                                                    color: 'black',
                                                    fontWeight: 500,
                                                    width: '3rem',
                                                    textAlign: 'right',
                                                }}
                                            >
                                                {((stat.value / data.raw_data.total_value.value) * 100).toFixed(1)}%
                                            </Typography>
                                        </Box>
                                    );
                                })}
                        </Stack>

                        <Typography fontSize={"0.7rem"} textAlign="center" marginTop={"1.5rem"}>
                                <span style={{ color: "#f444f0", fontWeight: 600 }}>
                                    ● &nbsp;
                                </span>
                                Followers and Non-Followers
                            </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Interactions;
